import usersReducer from "./usersSlice";
import userReducer from "./userSlice";

const users = {
  users: usersReducer,
  user: userReducer,
};

export default users;
